var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireworkRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 421.14 371.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#radial-gradient-7);\n      }\n\n      .cls-2 {\n        fill: url(#radial-gradient-34);\n      }\n\n      .cls-3 {\n        fill: url(#radial-gradient-10);\n      }\n\n      .cls-4 {\n        fill: url(#radial-gradient-31);\n      }\n\n      .cls-5 {\n        fill: url(#radial-gradient-28);\n      }\n\n      .cls-6 {\n        fill: url(#radial-gradient-16);\n      }\n\n      .cls-7 {\n        fill: url(#radial-gradient-20);\n      }\n\n      .cls-8 {\n        fill: url(#radial-gradient-21);\n      }\n\n      .cls-9 {\n        fill: url(#radial-gradient-8);\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient-5);\n      }\n\n      .cls-11 {\n        fill: url(#radial-gradient-4);\n      }\n\n      .cls-12 {\n        fill: url(#radial-gradient-32);\n      }\n\n      .cls-13 {\n        fill: url(#radial-gradient-25);\n      }\n\n      .cls-14 {\n        fill: url(#radial-gradient-26);\n      }\n\n      .cls-15 {\n        fill: url(#radial-gradient-22);\n      }\n\n      .cls-16 {\n        fill: url(#radial-gradient-6);\n      }\n\n      .cls-17 {\n        fill: url(#radial-gradient-19);\n      }\n\n      .cls-18 {\n        fill: url(#radial-gradient-12);\n      }\n\n      .cls-19 {\n        fill: url(#radial-gradient-35);\n      }\n\n      .cls-20 {\n        fill: url(#radial-gradient);\n      }\n\n      .cls-21 {\n        fill: url(#radial-gradient-27);\n      }\n\n      .cls-22 {\n        fill: url(#radial-gradient-13);\n      }\n\n      .cls-23 {\n        fill: url(#radial-gradient-30);\n      }\n\n      .cls-24 {\n        fill: url(#radial-gradient-24);\n      }\n\n      .cls-25 {\n        fill: url(#radial-gradient-15);\n      }\n\n      .cls-26 {\n        fill: url(#radial-gradient-2);\n      }\n\n      .cls-27 {\n        fill: url(#radial-gradient-3);\n      }\n\n      .cls-28 {\n        fill: url(#radial-gradient-17);\n      }\n\n      .cls-29 {\n        fill: url(#radial-gradient-33);\n      }\n\n      .cls-30 {\n        fill: url(#radial-gradient-14);\n      }\n\n      .cls-31 {\n        fill: url(#radial-gradient-29);\n      }\n\n      .cls-32 {\n        fill: url(#radial-gradient-23);\n      }\n\n      .cls-33 {\n        fill: url(#radial-gradient-36);\n      }\n\n      .cls-34 {\n        fill: url(#radial-gradient-11);\n      }\n\n      .cls-35 {\n        fill: url(#radial-gradient-18);\n      }\n\n      .cls-36 {\n        fill: url(#radial-gradient-9);\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 241.81,
    cy: 76.76,
    fx: 241.81,
    fy: 76.76,
    r: 54.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f74848"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 315.75,
    cy: 113.52,
    fx: 315.75,
    fy: 113.52,
    r: 62.44,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 161.04,
    cy: 285,
    fx: 161.04,
    fy: 285,
    r: 56.07,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 123.36,
    cy: 169.42,
    fx: 123.36,
    fy: 169.42,
    r: 48.76,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 114.58,
    cy: 141,
    fx: 114.58,
    fy: 141,
    r: 66.32,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 153.65,
    cy: 124.54,
    fx: 153.65,
    fy: 124.54,
    r: 52.85,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 91.19,
    cy: 204.01,
    fx: 91.19,
    fy: 204.01,
    r: 65.06,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 273,
    cy: 96.19,
    fx: 273,
    fy: 96.19,
    r: 35.11,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 327.48,
    cy: 121.79,
    fx: 327.48,
    fy: 121.79,
    r: 40.8,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 113.43,
    cy: 247.06,
    fx: 113.43,
    fy: 247.06,
    r: 54.45,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 120.68,
    cy: 268.78,
    fx: 120.68,
    fy: 268.78,
    r: 60.43,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 321.23,
    cy: 252.45,
    fx: 321.23,
    fy: 252.45,
    r: 46.53,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 242.39,
    cy: 295.32,
    fx: 242.39,
    fy: 295.32,
    r: 38.88,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 275.92,
    cy: 279.55,
    fx: 275.92,
    fy: 279.55,
    r: 36.91,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 301.26,
    cy: 274.89,
    fx: 301.26,
    fy: 274.89,
    r: 47.65,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 335.51,
    cy: 228.49,
    fx: 335.51,
    fy: 228.49,
    r: 54.15,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-17",
    cx: 340.7,
    cy: 177.41,
    fx: 340.7,
    fy: 177.41,
    r: 59.24,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 345.53,
    cy: 148.73,
    fx: 345.53,
    fy: 148.73,
    r: 54.16,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 294.78,
    cy: 101.07,
    fx: 294.78,
    fy: 101.07,
    r: 51.38,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 188,
    cy: 302.73,
    fx: 188,
    fy: 302.73,
    r: 53.88,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 169.67,
    cy: 101,
    fx: 169.67,
    fy: 101,
    r: 54.88,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-22",
    cx: 192.97,
    cy: 93.16,
    fx: 192.97,
    fy: 93.16,
    r: 51.83,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 138.17,
    cy: 281.36,
    fx: 138.17,
    fy: 281.36,
    r: 50.99,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-24",
    cx: 267.73,
    cy: 78.52,
    fx: 267.73,
    fy: 78.52,
    r: 50.72,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-25",
    cx: 103.92,
    cy: 230.04,
    fx: 103.92,
    fy: 230.04,
    r: 58.51,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 218.16,
    cy: 306.1,
    fx: 218.16,
    fy: 306.1,
    r: 47.01,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-27",
    cx: 91.1,
    cy: 185.88,
    fx: 91.1,
    fy: 185.88,
    r: 56.04,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-28",
    cx: 348.07,
    cy: 135.03,
    fx: 348.07,
    fy: 135.03,
    r: 54.03,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-29",
    cx: 125.29,
    cy: 125.97,
    fx: 125.29,
    fy: 125.97,
    r: 59.82,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-30",
    cx: 340.52,
    cy: 201.38,
    fx: 340.52,
    fy: 201.38,
    r: 51.75,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-31",
    cx: 303.81,
    cy: 104.88,
    fx: 303.81,
    fy: 104.88,
    r: 30.81,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-32",
    cx: 340.56,
    cy: 245.09,
    fx: 340.56,
    fy: 245.09,
    r: 30.6,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-33",
    cx: 163.01,
    cy: 113.13,
    fx: 163.01,
    fy: 113.13,
    r: 30.82,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 206.41,
    cy: 73.14,
    fx: 206.41,
    fy: 73.14,
    r: 45.38,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-35",
    cx: 171.75,
    cy: 302.08,
    fx: 171.75,
    fy: 302.08,
    r: 43.66,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 259.21,
    cy: 295.3,
    fx: 259.21,
    fy: 295.3,
    r: 46.81,
    xlinkHref: "#radial-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Orange"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m242.71,15.64c1.58,1.31,3.39,3.22,4.47,1.78,1.6-2.03-1.31-4.43-.73-5.73.65-1.31,5.95,0,5.59-1.81-.22-1.89-2.61-1.38-5.15-3.56,0,0,.15-2.1,1.02-4.79.8-2.54-2.61-1.6-3.85.58-1.23,2.18-1.23,3.27-2.98,1.89-1.74-1.38-1.81-1.74-3.56-3.05-1.74-1.23-1.96,2.69-.07,4.86,1.89,2.1-4.28,1.02-5.44,1.23-1.16.15,0,3.12,3.56,3.92,3.63.8-3.12,5.66-.58,6.82,2.08.95,3.57-1.98,5-2.92-4.9,22.89-7.32,138.65-7.32,138.65,5.37-5.89,11.15-114.27,10.05-137.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "m257.63,180.01s79.7-98.06,90.29-104.23c4.96-2.89,10.16-7,13.52-10.65.1.49.2,1.02.27,1.58.36,2.61,2.98.36,3.19-2.03.22-2.4-.22-3.48,1.89-2.9,2.03.58,2.32.8,4.36,1.23s.65-3.19-1.89-4.36c-2.54-1.16,3.34-2.61,4.36-3.27s-1.23-2.83-4.79-2.03c-3.56.73.51-6.31-2.25-6.31s-2.4,4.79-3.92,5.23c-1.67.51-6.17-2.4-6.75.07-.51,2.47,3.05,3.48,2.98,4.86,0,1.38-5.23,2.4-4.28,3.85.34.49.79.66,1.35.72-13.37,10.6-46.45,41.34-98.32,118.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "m218.07,230.09s-92.72,70.1-103.37,95.5c-.29-1.21-.71-2.23-1.73-1.94-2.03.58-1.38,3.63-2.47,4.21s-3.85-2.98-4.57-1.67c-.73,1.31,1.09,2.25,1.6,4.94,0,0-1.23,1.31-3.05,2.61-1.89,1.31.87,2.4,2.83,1.6,1.89-.73,2.47-1.6,2.9.22.44,1.81.36,2.03.8,3.77.51,1.74,2.61-.73,2.54-3.19-.15-2.4,3.34,1.45,4.21,1.96.87.51,1.6-2.03-.44-4.36-1.96-2.4,4.94-2.1,3.85-4.21-.4-.78-1.12-.96-1.92-.93,1.31-1.53,2.98-3.64,5.11-6.54,22.36-30.78,97.92-90.51,93.71-91.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "m186.57,194.81s-83.45-37.33-110.2-42.52c1.45-.86,2.81-1.8,1.97-2.92-1.38-2.03-4.5-.15-5.52-1.16s1.89-5.37.15-5.66c-1.67-.44-2.03,1.89-4.72,3.41,0,0-1.89-.8-4.06-2.4-2.03-1.6-2.32,1.89-.73,3.7s2.61,2.1.73,3.27c-1.81,1.09-2.1,1.09-3.85,2.25-1.74,1.16,1.81,2.61,4.43,1.67,2.61-1.02-.44,4.21-.58,5.37-.15,1.16,2.83,1.02,4.72-1.96,1.89-3.05,4.21,4.57,6.02,2.69,1.54-1.6-.84-4.05-1.15-5.63,23.88,10.06,118.81,49.61,112.78,39.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m39.95,107.57c3.7-.36-2.25,5.15-2.98,6.46-.73,1.31,3.19,2.4,6.9-.73,3.63-3.05,3.56,7.48,6.68,5.73,2.2-1.23,1.12-4.14.85-6.32.93.62,2.04,1.28,3.36,1.96,12.41,6.46,139.51,74.47,139.51,74.47,12.48-.07-126.01-73.24-136.24-78.97-.7-.4-1.37-.75-2.02-1.06,2.12-.5,4.1-1.13,3.61-2.86-1.02-3.12-5.73-1.96-6.61-3.63-.87-1.67,4.57-6.02,2.47-7.04-2.1-.94-3.41,1.89-7.69,2.76,0,0-2.1-1.81-4.21-4.57-2.03-2.83-3.7,1.45-2.47,4.36,1.23,2.9,2.54,3.77-.36,4.43-2.83.65-3.19.51-5.81,1.31-2.61.8,1.31,4.06,5.01,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m109.63,79.19c2.98.15-2.4,3.85-3.05,4.86-.65,1.02,2.25,2.32,5.44.22,3.19-2.03,1.89,6.39,4.5,5.37,1.82-.71,1.39-3.14,1.42-4.91.08.09.16.18.25.27,9.36,10.02,83.54,96.61,83.54,96.61,4.21-2.61-68.16-87.61-75.05-94.72-1.62-1.7-3.46-3.26-5.22-4.53,1.89-.15,3.84-.35,3.62-1.93-.44-2.61-4.28-2.25-4.72-3.7-.51-1.38,4.28-4.28,2.83-5.37-1.52-1.09-2.9.94-6.39,1.23,0,0-1.45-1.74-2.69-4.21-1.23-2.47-3.05.73-2.4,3.19.65,2.47,1.6,3.27-.8,3.56-2.32.22-2.54,0-4.79.44-2.1.36.51,3.34,3.48,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m18.63,205.74c31.68,2.98,140.64,2.55,151.46,3.45,13.28.94,12.27-.51,12.27-.51-108.16-8.33-148.23-8.15-163.06-6.97,1.33-1.91,2.93-4,1.27-5-2.54-1.6-5.08,2.1-6.75,1.45-1.67-.65-.65-6.97-2.69-6.39-2.18.65-1.38,3.48-3.63,6.68,0,0-2.54.07-5.73-.65-3.19-.73-1.6,3.27,1.09,4.5s4.14,1.09,2.54,3.27c-1.45,2.1-1.81,2.32-3.12,4.5-1.31,2.1,3.34,2.03,5.73-.51,2.4-2.47,1.74,4.94,2.03,6.31.36,1.31,3.7-.36,4.21-4.72.58-4.36,7.04,3.05,8.13-.07.84-2.42-2.32-3.84-3.75-5.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m287.75,52.55c-1.31,1.16-1.45,1.96-2.4.58-.8-1.31-.8-1.45-1.67-2.69-.87-1.23-1.89,1.31-1.09,3.19.8,1.81-3.05-.22-3.85-.36-.8-.15-.65,2.03,1.6,3.34,2.25,1.31-3.27,3.12-1.81,4.36,1.16.99,2.74-.49,3.85-.82-6.79,17.21-33.71,86.41-26.79,81.89,0,0,25.66-61.2,28.74-80.24.66,1.08,1.4,2.18,2.33,1.56,1.45-1.09.07-3.19.73-3.92.65-.73,3.85,1.23,4.14,0,0-1.31-1.6-1.45-2.83-3.41,0,0,.58-1.38,1.67-2.98,1.09-1.6-1.38-1.6-2.61-.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "m284.56,159.32s60.2-45.25,74.79-62.55c.04,1.4.17,2.76,1.35,2.6,2.03-.15,1.96-3.19,3.05-3.56s3.12,3.56,4.06,2.4c.94-1.16-.58-2.25-.58-4.94,0,0,1.38-1.09,3.34-1.96,1.96-.87-.44-2.4-2.4-1.96-1.96.44-2.61,1.09-2.69-.73-.07-1.74.07-1.96-.07-3.7s-2.61.22-2.98,2.54c-.22,2.32-2.9-1.96-3.63-2.54s-1.89,1.67-.44,4.21c1.45,2.54-5.01,1.16-4.36,3.27.55,1.71,3.2,1.01,4.46,1.43-16.96,13.32-83.31,65.99-73.92,65.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m48.73,267.54c2.25-2.83,3.63,5.08,5.66,3.34,2.03-1.74-1.23-5.08-.36-6.46.87-1.38,6.17-2.03,5.08-4.28-.69-1.43-2.3-1.34-3.62-1.36,7.46-1.34,27.8-11.47,47.31-15.12,26.49-4.94,80.28-19.02,83.76-20.69,0,0-115.79,21.58-131.84,31.68.35-.93.49-1.72-.19-1.92-1.52-.44-2.18,1.74-5.15,3.05,0,0-1.81-1.09-3.7-2.9s-2.47,1.6-1.16,3.63c1.31,2.03,2.4,2.47.44,3.34s-2.25.8-4.14,1.81c-1.81,1.02,1.45,2.9,4.21,2.1,2.69-.73-.87,4.14-1.23,5.23-.36,1.16,2.69,1.31,4.94-1.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "m63.55,296.94c14.89-7.46,52.46-32.45,133.32-66.85,0,0-111.42,43.49-136.52,61.96.14-1.57.09-2.99-1.24-3.03-2.54-.15-2.98,3.63-4.36,3.77s-3.27-4.94-4.57-3.7c-1.38,1.23.36,3.05-.15,6.31,0,0-1.89,1.09-4.5,1.81-2.61.73.15,3.05,2.61,2.9,2.47-.15,3.48-.8,3.19,1.38-.22,2.25-.44,2.47-.58,4.57-.07,2.1,3.27.15,4.14-2.61.73-2.83,3.19,2.98,4.06,3.85.8.8,2.61-1.74,1.23-5.15-1.31-3.48,6.39-.58,6.02-3.27-.21-1.29-1.4-1.7-2.67-1.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "m378.63,267.83c-1.74,1.02-.07-3.05-.07-3.85s-2.1-.51-3.19,1.89c-1.09,2.4-3.48-2.98-4.57-1.38-.46.63-.28,1.28.07,1.92-1.63-.43-3.84-.93-6.82-1.48-31.57-5.66-104.23-40.86-103.72-37.09,0,0,86.26,44.11,109.67,43.13-.73.62-1.24,1.26-.72,1.87,1.16,1.31,3.19-.36,4.06.36.8.65-.8,4.06.44,4.14,1.23,0,1.23-1.74,3.12-3.12,0,0,1.45.44,3.12,1.31,1.67.87,1.45-1.6.15-2.69-1.23-1.16-2.1-1.31-.8-2.32,1.23-1.02,1.38-1.02,2.54-1.96,1.09-1.02-1.6-1.74-3.27-.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "m246.52,339.76c-.58-1.31,1.38-5.44-.73-5.66-.54-.04-.98.14-1.34.42-.48-25.03-8.53-92.53-8.53-92.53-3.86-10.18-.94,67.07,4.27,93.28-.64-.96-1.28-1.83-1.87-1.31-1.02.94.29,2.47-.22,5.23,0,0-1.67.8-3.77,1.31-2.25.51,0,2.54,2.03,2.54s2.9-.58,2.61,1.31c-.22,1.81-.51,1.96-.58,3.77-.15,1.74,2.83.22,3.48-2.03.73-2.32,2.54,2.61,3.19,3.34.65.73,2.25-1.31,1.23-4.28-1.02-2.9,5.37-.22,5.08-2.54-.22-2.32-4.28-1.45-4.86-2.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m302.78,314.29c.15-1.38,3.85-4.14,2.1-5.23-1.74-1.23-3.7,1.31-4.79.8s-.15-4.94-1.67-4.57c-.69.17-.94.62-1.16,1.27-9.61-19.38-49.94-69.35-49.94-69.35-8.96-6.34,31.96,55.25,46.74,72.18-.66-.1-1.46-.25-2.32-.47-2.1-.58-1.23,2.25.58,3.19,1.81,1.02,2.83.87,1.67,2.4-1.16,1.45-1.38,1.6-2.4,3.05-1.02,1.45,2.32,1.6,4.06-.07,1.74-1.67,1.02,3.56,1.23,4.5.22,1.02,2.54-.07,3.12-3.12.58-3.05,4.86,2.4,5.66.22.8-2.1-3.05-3.34-2.9-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m347.7,310.3c-.07-1.45,3.27-5.01,1.23-5.95-2.03-.94-3.63,2.03-4.86,1.74-1.23-.29-1.16-5.08-2.61-4.5-.73.22-.96.72-1.11,1.43-17.23-21.89-89.03-72.93-89.03-72.93-3.77,1.81,20.03,13.57,49.07,43.19,18.78,19.08,29.41,28.72,35.42,33.57-.28,0-.57-.02-.87-.04-2.4-.22-.87,2.54,1.23,3.19,2.1.65,3.12.44,2.25,2.25-.87,1.74-1.16,1.89-1.89,3.63-.73,1.74,2.69,1.23,4.21-.87,1.45-2.03,1.74,3.56,2.1,4.43s2.69-.58,2.69-3.85,5.52,1.6,6.02-.8c.51-2.4-3.77-2.98-3.85-4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m403.38,224.07c-1.38-1.38-1.09-7.69-3.92-6.9-2.9.8-1.81,5.08-3.27,5.81-1.45.73-5.52-4.06-6.39-2.1-.59,1.17.01,2.08.79,3.35-33.9-4.7-128.75-6.9-128.75-6.9-18.44,3.03,92.6,11.87,129.01,11.89-.72.68-1.7,1.55-2.86,2.41-2.54,1.81,1.31,3.27,3.92,2.1,2.61-1.09,3.48-2.32,4.06.22.65,2.47.51,2.83,1.23,5.15.73,2.4,3.7-1.16,3.34-4.43-.22-3.34,4.72,1.96,5.95,2.54s2.1-2.9-.65-6.1c-2.83-3.19,6.75-3.12,5.23-5.95-1.6-2.83-6.24.36-7.69-1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "m418.11,163.89c-3.19-1.89,4.72-4.43,2.69-6.31-2.03-1.89-5.08,1.96-6.68,1.23s-3.05-6.1-5.08-4.57c-2.03,1.45-.07,4.72-1.09,5.73-1.02,1.02-5.66-1.81-5.95,0-.25.98.48,1.48,1.49,2.31-34.47,2.48-141.21,36.74-141.21,36.74-19.35,9.86,106.71-22.77,142.49-32.12-.36.66-.83,1.42-1.39,2.22-1.6,2.25,1.96,2.32,3.85.65,1.89-1.67,2.25-2.83,3.48-.87,1.23,1.96,1.16,2.25,2.47,3.92,1.23,1.74,2.69-1.96,1.6-4.57-1.16-2.61,4.43.36,5.59.51,1.16.15,1.02-2.98-2.25-4.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "m412.89,123.9c1.16-.15.07-3.05-3.48-3.85-3.56-.8,3.12-5.52.65-6.68-2.47-1.16-4.21,3.34-5.81,3.05-1.67-.22-4.57-4.79-6.1-2.83-1.45,1.96,1.31,4.36.65,5.66-.65,1.23-5.73-.07-5.52,1.74.16,1.03,1.01,1.34,2.15,1.79-24.4,11.66-92.73,44.77-117.7,61.57,0,0,93.1-38.69,120.16-57.07-.14.58-.32,1.23-.54,1.91-.8,2.54,2.54,1.6,3.77-.51,1.23-2.03,1.23-3.27,2.98-1.81,1.67,1.38,1.74,1.74,3.34,2.98,1.67,1.23,1.96-2.61.07-4.79-1.81-2.1,4.21-1.02,5.37-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "m318.45,51.61c.4.47.9.44,1.56.32-11.81,15.25-46.54,62.49-63.33,111.02,0,0,17.27-37.31,33.61-59.88,11.31-15.55,28.02-37.86,33.86-49.22.16.44.32.93.47,1.46.58,2.03,2.4-.07,2.32-1.96s-.58-2.69,1.16-2.47c1.74.22,1.89.44,3.63.51,1.67.07.15-2.61-2.03-3.19-2.18-.58,2.4-2.47,3.05-3.12.65-.65-1.31-2.03-4.06-1.09-2.69,1.02-.36-5.01-2.47-4.79-2.1.36-1.31,4.06-2.54,4.57s-5.15-1.16-5.23.8c-.15,1.96,2.83,2.4,2.98,3.48.15,1.16-3.85,2.47-2.98,3.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m170.53,358.27c-3.85-1.81,4.94-5.66,2.4-7.55-1.82-1.35-3.94.72-5.69,1.71,9.02-17.17,65.3-125.32,56.28-116.03,0,0-58.66,95.54-59.76,114.92-1.5-1.91-3.13-4.71-4.77-3.28-2.25,1.96.44,5.44-.65,6.75s-6.68-1.45-6.82.58c-.07,2.03,2.83,2.25,5.08,5.37,0,0-.73,2.47-2.32,5.15-1.67,2.69,2.54,2.47,4.5.36,1.96-2.1,2.25-3.48,3.85-1.38,1.6,2.03,1.6,2.4,3.19,4.28,1.67,1.89,2.98-2.54,1.31-5.52-1.67-2.98,5.08-.07,6.46,0,1.38.07.8-3.56-3.05-5.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m138.08,47.76c3.34-1.23.51,6.24,3.12,5.81,1.66-.28,1.86-2.23,2.17-3.8,6.05,11,62.28,119.5,62.28,119.5,8.2,3.77-52.26-112.72-56.33-119.62-.36-.59-.74-1.16-1.14-1.7,1.4.11,2.63,0,2.73-1.2.15-2.47-3.48-2.9-3.63-4.28-.15-1.38,4.79-3.12,3.63-4.43-1.23-1.23-2.98.36-6.17,0,0,0-1.02-1.81-1.74-4.36-.65-2.54-2.98.07-2.9,2.47.07,2.4.8,3.34-1.38,3.12-2.1-.22-2.4-.51-4.43-.58-2.03-.07-.15,3.19,2.54,3.92,2.69.73-2.98,3.12-3.77,3.85-.8.73,1.67,2.54,5.01,1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m172.71,38.03c3.56-.44-1.09,6.17,1.6,6.39,1.71.14,2.39-1.7,3.07-3.14,5.58,16.52,39.61,120.73,39.61,120.73,7.62,2.36-29.11-103.95-34.83-121.4,1.43.55,2.8.9,3.26-.32.8-2.32-2.61-3.7-2.47-5.08.15-1.38,5.44-1.81,4.57-3.34-.87-1.52-3.05-.36-5.95-1.6,0,0-.51-2.03-.58-4.72-.07-2.69-2.9-.65-3.34,1.74-.51,2.32-.07,3.48-2.1,2.61-1.96-.73-2.1-1.09-4.21-1.67-1.96-.65-1.02,3.05,1.45,4.5,2.4,1.38-3.63,2.32-4.57,2.83-1.02.51.87,2.9,4.5,2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m195.79,238c-95.59,40.21-113.09,74.33-113.09,74.33-5.66,9.07.44,20.18,11.32,4.57,20.47-29.03,101.76-78.9,101.76-78.9Zm-104.38,75.56c-5.66,7.55-4.94,3.27-4.94,3.27,9.94-25.04,65.25-51.53,65.25-51.53-15.75,9.73-28.02,18.36-36.8,24.82-8.93,6.61-16.84,14.44-23.52,23.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m285.86,24.46c11.03-15.46-1.45-17.57-8.13-9.22,0,0-26.42,27.87-32.52,131.38,0,0,20.03-93.27,40.65-122.16Zm-2.61-7.19s3.77-2.1-1.45,5.73c-6.17,9.29-11.03,19.31-14.23,29.9-3.27,10.52-7.19,24.97-11.32,43.04,0,0,6.61-60.97,27-78.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m185.04,216.15s-123.61-12.56-155.26,19.16c-31.07,31.21,48.05-13.21,108.88-15.97,41.3-1.81,46.38-3.19,46.38-3.19Zm-109.09,8.93c-13.21,2.61-26.06,7.26-37.96,13.57-10.16,5.37-7.19,1.09-7.19,1.09,23.81-22.43,98.42-22.94,98.42-22.94-22.28,2.61-40.28,5.73-53.28,8.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m212.34,364.3c17.86,30.34-.51-39.78,9.87-87.32,6.97-32.23,6.97-36.44,6.97-36.44,0,0-34.91,92.91-16.84,123.76Zm4.21-5.59c2.03,8.93-.65,5.73-.65,5.73-12.48-23.01,2.32-80.71,2.32-80.71-2.4,17.71-3.7,32.15-4.36,42.82-.65,10.74.22,21.63,2.69,32.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "m102.15,185.81c38.47,8.13,58.58,15.32,66.78,15.02-.07,0-120.42-43.84-146.84-25.4-30.27,21.05,22.5-1.89,80.06,10.38Zm-78.1-5.81c4.43-8.86,56.76-1.09,56.76-1.09-34.11-3.19-58.21,3.99-56.76,1.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m335.87,135.44c47.32-30.92,102.71-28.67,68.23-37.09-30.05-7.33-122.81,73.82-122.81,73.82,7.4-2.69,22.94-16.04,54.58-36.73Zm68.08-32.23c2.25,2.03-21.85,4.06-51.24,18.73,0,0,44.13-25.26,51.24-18.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "m98.67,107.21c6.24,5.37,93.34,70.77,93.34,70.77,0,0-84.05-84.49-121.22-100.31-37.16-15.9,21.63,24.17,27.87,29.54Zm-32.15-27.65c10.45-1.6,60.97,44.35,60.97,44.35-27.94-23.44-63.95-43.91-60.97-44.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "m267.72,207.44c11.4,2.69,45.15-.51,72.95-3.05,29.83-2.76,74.83,12.19,72.58-1.31-3.85-22.86-145.53,4.36-145.53,4.36Zm134.21-4.43c-13.36-1.67-23.15-3.05-33.82-2.69-10.45.22-22.36-.15-39.99,1.67,0,0,50.16-9.29,75.63-.51.15-.07,7.19,2.69-1.81,1.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m328.62,70.91c-10.74-6.82-51.53,68.37-51.53,68.37,25.91-35.93,62.28-61.55,51.53-68.37Zm-30.34,38.69s19.74-33.61,27.94-33.53c2.47,0-12.34,12.19-27.94,33.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m298.49,234.95c43.62,7.55,82.67,29.03,84.12,16.33,1.38-12.63-84.12-16.33-84.12-16.33Zm36,6.1s38.9,3.05,42.39,10.45c1.09,2.18-16.33-5.81-42.39-10.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m140.77,77.37c-11.25,6.1,23.3,34.33,46.67,71.86,0,0-35.49-77.95-46.67-71.86Zm1.96,5.44c8.2.51,25.55,35.42,25.55,35.42-14.01-22.43-28.02-35.57-25.55-35.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m222.86,135.15c-.07,0,3.12-102.71-24.75-121.43-22.21-14.88,6.61,37.96,15.39,71.5,5.15,19.67,6.46,50.16,9.36,49.94Zm-26.49-115.84c11.03,1.74,20.61,60.17,20.61,60.17-8.42-37.53-24.24-60.75-20.61-60.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m207.55,251.87c.07-.07-75.56,62.06-71.57,93.85,3.19,25.26,23.08-28.45,41.66-55.89,10.89-16.04,31.86-36.07,29.9-37.96Zm-66.49,91.6c-5.66-8.93,30.27-52.55,30.27-52.55-21.7,29.54-28.45,55.53-30.27,52.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m256.1,292.73c5.44,18.07,4.94,68.88,22.65,64.45,17.57-4.43-42.32-124.05-42.32-124.05,0,0,11.25,31.65,19.67,59.59Zm20.61,58.07c-.51,1.38-1.38,2.1-3.05-3.34-2.9-9.51-3.12-16.33-6.61-26.57-3.34-10.02-7.33-30.12-14.37-46.6,0,0,18.36,37.96,24.24,73.6.15.94.15,1.89-.22,2.9Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireworkRed);
export default __webpack_public_path__ + "static/media/firework-red.901bc6bd51def2c6b9916030ab81f373.svg";
export { ForwardRef as ReactComponent };